import withAuth from './withAuth';
import withoutAuth from './withoutAuth';

export default {
  withAuth,
  withoutAuth,
};
